module.exports = __webpack_public_path__ + "static/media/MBLogo.12355d71.svg";